import { useContext } from 'react';
import { CategoryContext } from './CategoryContext';

export const useCategoryContext = () => {
  const context = useContext(CategoryContext);

  if (context === undefined) {
    throw new Error('useCategoryContext must be used within a CategoryContext.Provider');
  }

  return context;
};
